<template>
    <div
        @click="placeholder = !placeholder"
        class="video-container aspect-w-16 aspect-h-9 bg-gray-200 rounded-2xl overflow-hidden"
    >
        <img
            v-if="placeholder"
            :src="image.sizes.medium_large"
            :width="image.sizes['medium_large-width']"
            :height="image.sizes['medium_large-height']"
            alt="why thumbnail"
            loading="lazy"
            class="absolute top-0 w-full h-full object-cover"
        />
        <video
            v-else
            playsinline
            autoplay
            loop
            controls
            class="absolute top-0 w-full h-full object-cover"
        >
            <source :src="video" />
        </video>
        <button
            v-if="placeholder"
            class="play-btn absolute top-1/2 left-1/2 focus:outline-none"
        />
    </div>
</template>

<script>
export default {
    name: 'VideoPlaceholder',
    props: {
        image: {
            type: Object,
            required: true,
        },
        video: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            placeholder: true,
        };
    },
};
</script>
